var common = require("../../utiles/common");
function viewModelFeishu(params) {
  var $this = this;
  var QRLoginObj;
  var goto;
  $this.openCode = function () {
    var state = sessionStorage.getItem("state")
      ? sessionStorage.getItem("state")
      : "";
    var data = common.fetch(params.baseUrl + params.url, {
      type: "GET",
      query: { state: state },
    });
    goto =
      "https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=" +
      data.appid +
      "&redirect_uri=" +
      data.redirect_uri +
      "&response_type=code&state=" +
      data.state;
    if (window.QRLogin) {
      QRLoginObj = window.QRLogin({
        id: "lark-qrcode-container",
        goto: goto,
        width: "350",
        height: "320",
        style: "border:none",
      });
    }
  };
  setTimeout(function () {
    $this.openCode();
    var handleMessage = function (event) {
      var origin = event.origin;
      // 使用 matchOrigin 方法来判断 message 来自页面的url是否合法
      if (QRLoginObj.matchOrigin(origin)) {
        var loginTmpCode = event.data;
        console.log(event);
        // 在授权页面地址上拼接上参数 tmp_code，并跳转
        window.location.href = goto+"&tmp_code="+loginTmpCode;
      }
    };
    if (typeof window.addEventListener != "undefined") {
      window.addEventListener("message", handleMessage, false);
    } else if (typeof window.attachEvent != "undefined") {
      window.attachEvent("onmessage", handleMessage);
    }
  }, 200);
}
// 组件销毁时循环函数设置为undefined
viewModelFeishu.prototype.dispose = function () {
  this.qrLoop = undefined;
};

module.exports = {
  register: function () {
    document.createElement("feishu-login");
    ko.components.register("feishu-login", {
      viewModel: viewModelFeishu,
      template: require("./Feishu.html"),
    });
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/template/feishu/Feishu.js
// module id = 109
// module chunks = 0